import {LoadingOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import cn from 'classnames';
import React from 'react';

import {DynamicIcon} from 'components/dynamic-icon';
import {TLinkDto} from 'shared/types/links';

import {ICustomLinkProps} from '../custom-link';
import s from './link-view.module.less';

interface ICustomLinkViewProps {
    properties: TLinkDto['linkProperties'];
    isLoading?: boolean;
    isSubmenuItem?: ICustomLinkProps['isSubmenuItem'];
    className?: cn.Argument;
}

export const LinkView = ({
    properties,
    isLoading,
    isSubmenuItem = false,
    className,
}: ICustomLinkViewProps) => {
    const {
        icon,
        title = 'Ссылка',
        type,
    } = properties ?? {};

    const iconToShow = isLoading ? (
        <div className={cn('mr-1')}>
            <LoadingOutlined />
        </div>
    ) : icon && (
        <DynamicIcon
            className={cn({
                'mr-1': type === 'link',
            })}
            type={icon}
        />
    );

    if (title === null) return null;

    if (type === 'button' && !isSubmenuItem) {
        return (
            <Button
                disabled={isLoading}
                type="default"
                className={s['custom-link-view__button']}
            >
                {iconToShow}
                {title}
            </Button>
        );
    }

    return (
        <div className={cn(
            className,
            {
                [s['custom-link-view__default']]: type === 'submenu',
                [s['custom-link-view__link']]: type !== 'submenu' && !isSubmenuItem,
                [s['custom-link-view__kebab-action']]: isSubmenuItem,
                [s['custom-link-view__link_loading']]: isLoading,
            }
        )}
        >
            {iconToShow}
            {title ?? (!iconToShow && 'Ссылка')}
        </div>
    );
};
